/* eslint formatjs/no-literal-string-in-jsx: "error" */
import { useBenefitEnrollment } from "../../context/enrollment/BenefitEnrollmentContext"
import React from "react"
import PropTypes from "prop-types"
import { TextLink } from "../atoms/links/TextLink"
import { ButtonPrimary } from "../atoms/buttons/ButtonPrimary"
import { FormattedMessage } from "react-intl"

const Activate = ({ error, onSubmit, submitting }) => {
  const { needsBenefitEnrollment } = useBenefitEnrollment()
  const benefitEnrollmentError = error && needsBenefitEnrollment
  const defaultError = error && !needsBenefitEnrollment

  const needsBenefitEnrollmentErrorMessage = () => {
    return (
      <p className="lh-copy mb0 carrot-red">
        <FormattedMessage
          defaultMessage="We’re unable to activate your Carrot Card because we need some information about your health insurance. Please <link> share a few details about your plan </link> and try again."
          values={{
            link: (linkContent) => (
              <TextLink to={"/#needs-benefit-enrollment"}>
                <span>{linkContent}</span>
              </TextLink>
            )
          }}
        />
      </p>
    )
  }

  const defaultErrorMessage = () => {
    return (
      <p className="lh-copy mb0 carrot-red">
        <FormattedMessage
          defaultMessage="There was a problem activating your Carrot Card®, and we're working on it. Please try again later, or <link>contact our care team</link> if you have any questions."
          values={{
            link: (linkContent) => (
              <TextLink to={"/talk-to-carrot"}>
                <span>{linkContent}</span>
              </TextLink>
            )
          }}
        />
      </p>
    )
  }

  return (
    <div className="pa3-ns pv1">
      <div className="mw6 center pa3-ns pv1">
        <form className="pa4-ns pa3 bg-white" onSubmit={onSubmit}>
          <h1 className="publico-text mt0 mb4 black">
            <FormattedMessage defaultMessage="Activate your Carrot Card®" />
          </h1>
          <p className="lh-copy mt0 black-60">
            <FormattedMessage defaultMessage="Once you activate your Carrot Card®, you’ll be able to use to pay for eligible services at eligible providers" />
          </p>
          {defaultError && defaultErrorMessage()}
          {benefitEnrollmentError && needsBenefitEnrollmentErrorMessage()}
          <div className="mt4 flex flex-row justify-end">
            <ButtonPrimary onClick={onSubmit} enabled={!submitting}>
              {submitting ? (
                <FormattedMessage defaultMessage="Activating" />
              ) : (
                <FormattedMessage defaultMessage="Activate" />
              )}
            </ButtonPrimary>
          </div>
        </form>
      </div>
    </div>
  )
}

Activate.propTypes = {
  error: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  needsBenefitEnrollment: PropTypes.bool
}

export default Activate
